// @flow
import { createSelector } from 'reselect';
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const SET_WINDOW_SIZE = 'la/ui/windowSize/SET';

// reducer
const DEFAULT_STATE = {
    height: 1024,
    width: 1024,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case SET_WINDOW_SIZE:
            return {
                ...state,
                height: action.payload.height,
                width: action.payload.width,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.windowSize;

export const getWindowSize = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
type SetWindowSizeParams = {
    height: number,
    width: number,
};

export const setWindowSize = ({ height, width }: SetWindowSizeParams) => ({
    payload: { height, width },
    type: SET_WINDOW_SIZE,
});
